import styled from "styled-components"

const Link = styled.a`
  width: 100%;
  height: 50px;
  position: relative;
  font-size: 14px;
  appearance: none;
  border-radius: 13px;
  color: #707070;
  background: #c5ccce55;
  box-shadow: 0px 3px 6px #00000029;
  cursor: pointer;
  outline: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-touch-callout: none;
  text-decoration: none;
  padding: 10px;
  display: flex;
  text-transform: uppercase;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
`

export default Link
